import React from "react";
import Invitation from "../../Components/OrganizationSettings/InvitationManagement/Invitation";
import { InvitationProvider } from "../../Context/Invitation/InvitationContext";
import NoAccessComponent from "../../Components/Shared/Error/NoAccess";

const InvitationPage = ({ role }) => {
    //if (organization.isTenantOrganization) return <NoAccessToTenantOrganization />;
    const authorized = role.roleType === 'Owner' || role.roleType === 'Administrator';
    if (!authorized) {
        return <NoAccessComponent />
    }
    return (
        <InvitationProvider>
            <Invitation />
        </InvitationProvider>
    );
}
export default InvitationPage;